import axios from 'axios';

export default class MotivoRevisaoService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    async listarMotivosRevisao() {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + `motivo-revisao`,
                {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }
}
